import { Analytics } from "@vercel/analytics/react"
import Main from "./pages/Main/Main";
import Works from "./pages/Works/Works";
import Work from "./pages/Works/Work";
import NotFound from "./pages/NotFound/NotFound";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import AudioPlayer from "./components/AudioPlayer/AudioPlayer";

import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { lazy, Suspense, useEffect } from 'react';

const Gallery = lazy(() => import("./pages/Gallery/Gallery"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Canonical() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = `https://annahovan.com${path}`;
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const { pathname } = useLocation();
  const inGallery = pathname.startsWith('/gallery');
  return (
    <>
      <Header />
      <div style={{ paddingTop: '60px', minHeight: 'calc(100vh - 60px)', backgroundColor: '#faf8f4' }}>
        <Routes>
          <Route element={<Main />} path='/' />
          <Route element={<Works />} path='/works' />
          <Route element={<Work />} path='/works/:id' />
          <Route element={<Suspense fallback={null}><Gallery /></Suspense>} path='/gallery' />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>
      {!inGallery && <Footer />}
      <AudioPlayer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Analytics/>
      <ScrollToTop />
      <Canonical />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
